<template>


  <head>

    <meta charset="utf-8"/>
    <title>Maji H2O | All Trip requests</title>
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <meta content="Premium Multipurpose Admin & Dashboard Template" name="description"/>
    <meta content="Themesbrand" name="author"/>
    Business with AActive SBP Certificate
    <!-- App favicon -->
    <link rel="shortcut icon" href="assets/images/favicon.svg">

    <!-- DataTables -->
    <link href="assets/libs/datatables.net-bs4/css/dataTables.bootstrap4.min.css" rel="stylesheet" type="text/css"/>
    <link href="assets/libs/datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css" rel="stylesheet"
          type="text/css"/>
    <!-- Bootstrap Rating css -->
    <link href="assets/libs/bootstrap-rating/bootstrap-rating.css" rel="stylesheet" type="text/css"/>

    <!-- Bootstrap Css -->
    <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css"/>
    <!-- Bootstrap Rating css -->
    <link href="assets/libs/bootstrap-rating/bootstrap-rating.css" rel="stylesheet" type="text/css"/>
    <!-- Bootstrap select styling -->
    <link rel="stylesheet"
          href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css">
    <!-- Icons Css -->
    <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css"/>
    <!-- App Css-->
    <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css"/>
    <!-- custom Css-->
    <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css"/>

    <!-- map Css-->
    <link href="assets/css/map.css" id="app-style" rel="stylesheet" type="text/css"/>


  </head>

  <body @contextmenu.prevent data-sidebar="dark">
  <!-- Loader -->

  <!-- Begin page -->
  <div id="layout-wrapper">

    <NavigationBar/>


    <!-- ============================================================== -->
    <!-- Start right Content here -->
    <!-- ============================================================== -->
    <div id="content" class="content-minimize">
      <!-- Business details side bar -->
      <div class="modal fade trip-details-modal" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h5>Kelvin's trip details</h5>

              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">

              <div class="d-flex align-items-center">
                <div class="flex-shrink-0 me-3">
                  <div class="avatar-xs">
                                        <span class="avatar-title rounded-circle bg-primary bg-soft text-primary text-uppercase">
                                            <strong>KN</strong>
                                        </span>
                  </div>
                </div>

                <div class="flex-grow-1">
                  <h5 class="modal-title">Trip With Alex</h5>
                  <p class="mb-0 pb-0"><span class="text-muted">Sat, 26 Feb 2022</span></p>
                </div>
              </div>


              <div class="mb-3 row">
                <div class="col-12 pt-4">
                  <ul class="verti-timeline list-unstyled mt-3">
                    <li class="event-list active">
                      <div class="event-timeline-dot">
                        <i class="bx bxs-right-arrow-circle font-size-18"></i>
                      </div>
                      <div class="d-flex">
                        <div class="flex-shrink-0 me-3">
                          <h5 class="font-size-14">16:05 <i
                              class="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2"></i>
                          </h5>
                        </div>
                        <div class="flex-grow-1">
                          <div>
                            Accra Road
                          </div>
                        </div>
                      </div>
                    </li>
                    <li class="event-list">
                      <div class="event-timeline-dot">
                        <i class="bx bx-right-arrow-circle font-size-18"></i>
                      </div>
                      <div class="d-flex">
                        <div class="flex-shrink-0 me-3">
                          <h5 class="font-size-14">On Transit <i
                              class="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2"></i>
                          </h5>
                        </div>
                        <div class="flex-grow-1">
                          <div>
                            Embakasi
                          </div>
                        </div>
                      </div>
                    </li>

                  </ul>
                </div>
                <div class="col-12 pt-4">
                  <h6 class="text-capitalize">2KM To go</h6>

                </div>
                <div class="col-12 pt-4">
                  <h6>Payment</h6>
                  <table class="table">
                    <tbody>
                    <tr>
                      <td>Fare. Reguler cab</td>
                      <td class="text-right">KES 250.00</td>
                    </tr>
                    </tbody>
                    <tfoot>
                    <tr>
                      <th>Pending</th>
                      <th class="text-right">Waiting</th>
                    </tr>

                    </tfoot>

                  </table>

                </div>
              </div>
              <button class="btn btn-primary"><i class="bx bx-printer font-size-16 align-middle me-2"></i>Print
                Receipt
              </button>
              <button class="btn btn-outline-primary waves-effect"><i
                  class="mdi mdi-email-send-outline font-size-16 align-middle me-2"></i>Resend Receipt
              </button>

            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!-- trip details modal -->

      <div class="page-content">
        <div class="container-fluid">

          <!-- start page title -->
          <div class="row">
            <div class="col-12">

              <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                <h4 class="mb-sm-0 font-size-18">Map view</h4>

                <div class="page-title-right">
                  <ol class="breadcrumb m-0">
                    <li class="breadcrumb-item"><a href="index.html">Dashboards</a></li>
                    <li class="breadcrumb-item active">map View</li>
                  </ol>
                </div>

              </div>
            </div>
          </div>
          <!-- end page title -->

          <!-- tool bar -->

          <ToolBar/>


          <div class="row">
            <div class="col-12">
              <div class="card">
                <div class="card-header bg-white boarder-bottom-1 d-none">
                  <div class="row d-flex justify-content-between">
                    <div class="col-12">
                      <div class="search-box mb-2 me-2">
                        <div class="position-relative">
                          <input type="text"
                                 class="form-control bg-light border-light rounded map-searcher"
                                 id="pac-inpu" placeholder="Search for location">
                          <i class="bx bx-search-alt search-icon"></i>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
                <div class="card-body">
                  <div id="map" class="w-100 mt-1 h-100 live-map-cont main-map-container"></div>
                </div>

              </div>

              <div class="">
                <div class="position-relative ">


                  <!-- map serach input box -->
                  <div class="form-group map-searcher">

                    <input type="text" class="form-control form-control-lg text-black"
                           placeholder="Search for a location" id="pac-input">
                    <button title="Clear search results"
                            class="btn btn-transparent border-0 clear-map"><i
                        class="mdi mdi-close d-none"></i></button>
                  </div>

                  <!-- key button -->
                  <div class="map-key-card card">
                    <div class="card-body">
                      <i class="mdi mdi-key-variant"></i>
                    </div>
                  </div>

                  <!-- key items -->
                  <div class="card map-card animated slideInLeft d-none">
                    <span class="close-map-key"><i class="zmdi zmdi-close"></i></span>
                    <div class="card-body">
                      <h4 class="card-title">Map Key</h4>

                    </div>
                    <div class="listview py-4 map-key">
                                            <span class="listview__item py-0">
                                                    <img src="assets/images/map-assets/damaged.svg"
                                                         class="listview__img" alt="">

                                                    <div class="listview__content d-flex align-items-center">
                                                        <div class="listview__heading"><strong>Damaged Ad Plates</strong></div>
                                                    </div>
                                                </span>

                      <span class="listview__item py-0">
                                                    <img src="assets/images/map-assets/available.svg"
                                                         class="listview__img" alt="">

                                                    <div class="listview__content d-flex align-items-center">
                                                        <div class="listview__heading"><strong>Available Ad Plates</strong></div>
                                                    </div>
                                                </span>

                      <span class="listview__item py-0">
                                                    <img src="assets/images/map-assets/rented.svg" class="listview__img"
                                                         alt="">

                                                    <div class="listview__content d-flex align-items-center">
                                                        <div class="listview__heading"><strong>Rented Ad Plates</strong></div>
                                                    </div>
                                                </span>

                      <span class="listview__item py-0">
                                                    <img src="assets/images/map-assets/multiple-plates.svg"
                                                         class="listview__img" alt="">

                                                    <div class="listview__content d-flex align-items-center">
                                                        <div class="listview__heading"><strong>Multiple sided Ad Plates</strong></div>
                                                    </div>
                                                </span>


                      <span class="listview__item py-0">
                                                    <img src="assets/images/map-assets/rejected.svg"
                                                         class="listview__img" alt="">

                                                    <div class="listview__content d-flex align-items-center">
                                                        <div class="listview__heading"><strong>Rejected Applications</strong></div>
                                                    </div>
                                                </span>

                      <span class="listview__item py-0">
                                                    <img src="assets/images/map-assets/pending.svg"
                                                         class="listview__img" alt="">

                                                    <div class="listview__content d-flex align-items-center">
                                                        <div class="listview__heading"><strong>Pending applications</strong></div>
                                                    </div>
                                                </span>

                      <span class="listview__item py-0">
                                                    <img src="assets/images/map-assets/approved.svg"
                                                         class="listview__img" alt="">

                                                    <div class="listview__content d-flex align-items-center">
                                                        <div class="listview__heading"><strong>Approved Applications</strong></div>
                                                    </div>
                                                </span>


                      <span class="listview__item py-0">
                                                    <img src="assets/images/map-assets/warning.svg"
                                                         class="listview__img" alt="">

                                                    <div class="listview__content d-flex align-items-center">
                                                        <div class="listview__heading"><strong>Incidents</strong></div>
                                                    </div>
                                                </span>

                      <span class="listview__item py-0">
                                                    <img src="assets/images/map-assets/active-agent.svg"
                                                         class="listview__img" alt="">

                                                    <div class="listview__content d-flex align-items-center">
                                                        <div class="listview__heading"><strong>active-agent</strong></div>
                                                    </div>
                                                </span>

                      <span class="listview__item py-0">
                                                    <img src="assets/images/map-assets/inactive-agent.svg"
                                                         class="listview__img" alt="">

                                                    <div class="listview__content d-flex align-items-center">
                                                        <div class="listview__heading"><strong>Inactive agents</strong></div>
                                                    </div>
                                                </span>

                      <span class="listview__item py-0">
                                                    <img src="assets/images/map-assets/parliament.svg"
                                                         class="listview__img" alt="">

                                                    <div class="listview__content d-flex align-items-center">
                                                        <div class="listview__heading"><strong>City Hall</strong></div>
                                                    </div>
                                                </span>


                      <span class="listview__item py-0">
                                                    <img src="assets/images/map-assets/flag.svg" class="listview__img"
                                                         alt="">

                                                    <div class="listview__content d-flex align-items-center">
                                                        <div class="listview__heading"><strong>Service/Collection Point</strong></div>
                                                    </div>
                                                </span>


                    </div>
                  </div>

                </div>

              </div>
            </div>
            <!-- end col -->
          </div>
          <!-- end row -->


        </div>
        <!-- container-fluid -->
      </div>
      <!-- End Page-content -->

      <!-- Transaction Modal -->
      <div class="modal fade transaction-detailModal" tabindex="-1" role="dialog"
           aria-labelledby="transaction-detailModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="transaction-detailModalLabel">Transactions Details</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">


              <div class="table-responsive mt-4">
                <table class="table align-middle table-nowrap">
                  <tbody>
                  <tr>
                    <td style="width: 30%">
                      <p class="mb-0">Car Plate Number</p>
                    </td>
                    <td style="width: 25%">
                      <h5 class="mb-0 text-uppercase">UAG 1235p</h5>
                    </td>

                  </tr>
                  <tr>
                    <td>
                      <p class="mb-0">Vehicle Category</p>
                    </td>
                    <td>
                      <h5 class="mb-0">Salon Car</h5>
                    </td>

                  </tr>
                  <tr>
                    <td>
                      <p class="mb-0">Payment Date</p>
                    </td>
                    <td>
                      <h5 class="mb-0">22 Apr 2022 06:54PM</h5>
                    </td>

                  </tr>
                  <tr>
                    <td>
                      <p class="mb-0">San Diego</p>
                    </td>
                    <td>
                      <h5 class="mb-0">1,026</h5>
                    </td>

                  </tr>
                  <tr>
                    <td colspan="2">
                      <p class="mb-0 pb-0">Amount Paid</p>
                      <h3>UGX 2,000</h3>
                    </td>
                  </tr>
                  <TR>
                    <td col-span="2">
                      <p class="mb-2">Attended By<span class="text-primary"> Alex Sebeye</span>
                      </p>
                      <p class="mb-4">Toll taker's No. <span
                          class="text-primary">0704549859</span></p>
                    </td>
                  </TR>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
            </div>
          </div>
        </div>
      </div>

      <!-- Bill Receipting -->
      <div class="modal fade receipting-Modal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
           role="dialog" aria-labelledby="transaction-detailModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header text-capitalize">
              <h5 class="modal-title" id="#">Receipt The bill (Bill No. 123456)</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-12">
                  <div class="form-group">
                    <label for="">Select Payment Method</label>
                    <select name="" class="form-select select-payment-method" id="">
                      <option value="Mpesa">MPESA</option>
                      <option value="Bank">Bank</option>
                    </select>
                  </div>
                </div>

                <div class="col-12">
                  <div class="form-group">
                    <label for="">Payer's Name</label>
                    <!--  by default this should be the name to the driveer selected from the Db -->
                    <input type="text" value="Kelvin Njuguna" class="form-control"
                           placeholder="Enter payer's name" name="" id="">
                    <small>You can change if the payer is different from the driver</small>
                  </div>
                </div>

                <div class="col-12">
                  <div class="form-group">
                    <label for="">Phone No.</label>
                    <!--  Directly from the DB -->
                    <input type="text" value="0704549859" class="form-control"
                           placeholder="Enter payer's name" name="" id="">
                    <small>You can change if the payer is different from the driver</small>
                  </div>
                </div>

                <div class="mb-4">
                  <label>Payment Date</label>
                  <div class="input-group" id="datepicker2">
                    <input type="text" class="form-control" placeholder="dd M, yyyy"
                           data-date-format="dd M, yyyy" data-date-container='#datepicker2'
                           data-provide="datepicker" data-date-autoclose="true">

                    <span class="input-group-text"><i class="mdi mdi-calendar"></i></span>
                  </div>
                  <!-- input-group -->
                </div>

                <!-- Mpesa -->
                <div class="col-12 mpesa-mode  driver-pay-method">
                  <div class="row">
                    <div class="col-12">
                      <div class="form-group">
                        <label for="">Mpesa Ref No.</label>
                        <input type="text" class="form-control"
                               placeholder="Enter Mpesa Ref No." name="" id="">
                      </div>
                    </div>
                  </div>
                </div>
                <!-- cash -->
                <div class="col-12 cash-mode d-none driver-pay-method">
                  <div class="row">
                    <div class="col-12">
                      <div class="form-group">
                        <label for="">Received Amount</label>
                        <input type="text" class="form-control"
                               placeholder="Enter  amount received " name="" id="">
                      </div>
                    </div>
                  </div>
                </div>

                <!-- bank payment -->
                <div class="col-12 bank-mode d-none driver-pay-method">
                  <div class="row">
                    <div class="col-12">
                      <div class="form-group">
                        <label for="">Bank</label>
                        <input type="text" class="form-control"
                               placeholder="Enter the bank's Name" name="" id="">
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="form-group">
                        <label for="">Transaction Ref No.</label>
                        <input type="text" class="form-control"
                               placeholder="Enter Bank's transaction's Ref No" name="" id="">
                      </div>
                    </div>
                  </div>
                </div>
              </div>


            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
              <button type="button" class="btn btn-success">Receipt Bill</button>
            </div>

          </div>
        </div>
      </div>
      <!-- end modal -->
      <!-- end modal -->
      <!-- filter right of canvus -->
      <div class="offcanvas offcanvas-end" tabindex="-1" id="dt__filter" aria-labelledby="offcanvasRightLabel">
        <div class="offcanvas-header">
          <h5 id="offcanvasRightLabel">Filter Member Register</h5>
          <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas"
                  aria-label="Close"></button>
        </div>
        <div class="offcanvas-body">
          <div class="col-12 mb-4">
            <div class="alert alert-info alert-border" role="alert">
              Use this section to filter the table
            </div>
          </div>
          <div class="col-12">
            <div class="mb-4">
              <label>Last collection date Range</label>

              <div class="input-daterange input-group" id="datepicker6" data-date-format="dd M, yyyy"
                   data-date-autoclose="true" data-provide="datepicker"
                   data-date-container='#datepicker6'>
                <input type="text" class="form-control date-drop-input" name="start"
                       placeholder="Start Date" readonly/>
                <input type="text" class="form-control date-drop-input" name="end"
                       placeholder="End Date" readonly/>
              </div>
            </div>
          </div>

          <div class="col-12">
            <div class="mb-4">
              <label>Milk collections amount range</label>

              <div class="input-daterange input-group">
                <input type=" text " class="form-control " name="" placeholder="Min Amount"/>
                <input type="text " class="form-control " name="" placeholder="Max Amount"/>
              </div>
            </div>
          </div>

          <div class="col-12">
            <div class="mb-4">
              <label>Land Size</label>

              <div class="input-daterange input-group">
                <input type=" text " class="form-control " name="" placeholder="Min Size"/>
                <input type="text " class="form-control " name="" placeholder="Max size"/>
              </div>
              <span class="text-muted"><small>Specify a range for the field size</small></span>
            </div>
          </div>

          <div class="col-12">
            <div class="mb-4">
              <label>Route</label>
              <div class="row">
                <div class="col-md-12 col-lg-6">
                  <div class="form-check form-check-primary mb-3">
                    <input class="form-check-input" type="checkbox" id="allTollTakers" checked>
                    <label class="form-check-label text-capitalize" for="allTollTakers">
                      All Routes
                    </label>
                  </div>
                </div>

                <div class="col-md-12 col-lg-6">
                  <div class="form-check form-check-primary mb-3">
                    <input class="form-check-input" type="checkbox" id="tollTaker1">
                    <label class="form-check-label text-capitalize" for="tollTaker1">
                      Nkubu
                    </label>
                  </div>
                </div>

                <div class="col-md-12 col-lg-6">
                  <div class="form-check form-check-primary mb-3">
                    <input class="form-check-input" type="checkbox" id="tollTaker3">
                    <label class="form-check-label text-capitalize" for="tollTaker3">
                      Mutithi
                    </label>
                  </div>
                </div>

                <div class="col-md-12 col-lg-6">
                  <div class="form-check form-check-primary mb-3">
                    <input class="form-check-input" type="checkbox" id="tollTaker4">
                    <label class="form-check-label text-capitalize" for="tollTaker4">
                      Mukinduri
                    </label>
                  </div>
                </div>

                <div class="col-md-12 col-lg-6">
                  <div class="form-check form-check-primary mb-3">
                    <input class="form-check-input" type="checkbox" id="tollTaker5">
                    <label class="form-check-label text-capitalize" for="tollTaker5">
                      Kathangeri
                    </label>
                  </div>
                </div>
              </div>


            </div>
          </div>

          <div class="col-12">
            <div class="mb-4">
              <button type="button" class="btn btn-primary waves-effect waves-light w-100">
                <i class="mdi mdi-filter-variant font-size-16 align-middle me-2"></i> Filter Table
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- offcanvasess begining. they will be containing the different side bars with the statuses -->
      <div class="offcanvas offcanvas-start" tabindex="-1" id="offcanvasExample" aria-labelledby="offcanvasExampleLabel">
        <div class="offcanvas-header">
          <div class="d-flex">
            <div class="flex-grow-1 overflow-hidden pe-5">
              <div class=" mb-1 text-capitalize d-flex">
                <h5 class="text-truncate font-size-14 mb-0">
                  {{business.businessName}}
                </h5>
              </div>
              <p class="text-truncate mb-0 text-uppercase">Business ID <strong>{{business.businessID}}</strong></p>
            </div>


          </div>
          <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
        </div>
        <div class="offcanvas-body">
          <!--

                              <div v-bind:class="{ 'alert': true, 'alert-success': color === 'alert-success', 'alert-danger': color === 'alert-danger' }" role="alert">
                                  Business with An expired SBP Certificate
                              </div>
          -->


          <div v-bind:class="{ 'alert': true, 'alert-success': color === 'alert-success', 'alert-danger': color === 'alert-danger' }" role="alert">

            <strong>Business Category</strong>
            <p>{{business.businessCategory}}</p>

            <strong>Business Sub Category</strong>
            <p>{{business.businessSubCategory}}</p>

            <strong>Business Activity</strong>
            <p>{{business.businessDes}}</p>

            <strong>Paid SBP Amount</strong>
            <h5>KES {{numberFormat(business.receiptAmount)}}</h5>

            <a class="" href="PrintDocs/Receipts/receipts.html">Receipt No. {{business.billNo}}</a>


          </div>



          <div class="card shadow-none border">
            <div class="card-body p-3">
              <div class="">

                <div class="d-flex">
                  <div class="overflow-hidden me-auto">
                    <h5 class="font-size-14 text-truncate mb-1"><a href="javascript: void(0);" class="text-body">Permit Details</a></h5>

                  </div>

                </div>

                <div class="card-body bg-light d-flex mb-4 mt-4">
                  <p class=" mb-0 ">
                    <i class="mdi mdi-file-check-outline text-success align-middle me-3 font-size-24 ml-5 mr-5 "></i>
                  </p>
                  <div>
                    <p class="text-muted mb-0 ">Permit Status</p>
                    <p class="mb-0 ">
                      <strong class="fw-semibold">
                        <span class="">Active</span>
                      </strong>
                    </p>
                  </div>
                </div>

                <div class="card-body bg-light d-flex mb-4 mt-4">
                  <p class=" mb-0 ">
                    <i class="mdi mdi-calendar-month text-warning align-middle me-3 font-size-24 ml-5 mr-5 "></i>
                  </p>
                  <div>
                    <p class="text-muted mb-0 ">Duration Paid For</p>
                    <p class="mb-0 ">
                      <strong class="fw-semibold">
                        <span class="">{{formatDate(business.startDate)}} - {{formatDate(business.endDate)}}</span>
                      </strong>
                    </p>
                  </div>
                </div>

                <div class="card-body bg-light d-flex mb-4 mt-4">
                  <p class=" mb-0 ">
                    <i class="mdi mdi-file-certificate-outline text-warning align-middle me-3 font-size-24 ml-5 mr-5 "></i>
                  </p>
                  <div>
                    <p class="text-muted mb-0 ">Permit Number</p>
                    <p class="mb-0 ">
                      <strong class="fw-semibold">
                        <span class="">{{business.businessID}}</span>
                      </strong>
                    </p>
                  </div>
                </div>

                <div class="card-body bg-light d-flex mb-4 mt-4">
                  <p class=" mb-0 ">
                    <i class="mdi mdi-calendar-clock text-info align-middle me-3 font-size-24 ml-5 mr-5 "></i>
                  </p>
                  <div>
                    <p class="text-muted mb-0 ">Date Issued</p>
                    <p class="mb-0 ">
                      <strong class="fw-semibold">
                        <span class="">{{formatDate(business.dateOfIssue)}}</span>
                      </strong>
                    </p>
                  </div>
                </div>



                <div class="card-body bg-light d-flex mb-4 mt-4">
                  <p class=" mb-0 ">
                    <i class="mdi mdi-file-document-multiple text-warning align-middle me-3 font-size-24 ml-5 mr-5 "></i>
                  </p>
                  <div>
                    <p class="text-muted mb-0 ">Previous SBP Permits</p>
                    <p class="mb-0 ">
                      <strong class="fw-semibold">
                        <span class=""><a href="">{{business.permitsCount}} Previous Permit(s)</a></span>
                      </strong>
                    </p>
                  </div>
                </div>

                <div class="card-body bg-light d-flex mb-4 mt-4">
                  <p class=" mb-0 ">
                    <i class="mdi mdi-cash-multiple text-success align-middle me-3 font-size-24 ml-5 mr-5 "></i>
                  </p>
                  <div>
                    <p class="text-muted mb-0 ">Total Charges Paid</p>
                    <p class="mb-0 ">
                      <strong class="fw-semibold">
                        <span class="">KES {{numberFormat(business.receiptAmount)}}</span>
                      </strong>
                    </p>
                  </div>
                </div>

                <div class="d-flex">
                  <div class="overflow-hidden w-100">

                    <a @click="printTradePermit(business.businessID)" type="button" class="btn btn-primary waves-effect waves-light w-100 text-center btn-100 btn-flex" fdprocessedid="1zlfom">
                      <i class="mdi mdi-download font-size-16 align-middle me-2"></i> Download Permit
                    </a>
                  </div>

                </div>




              </div>
            </div>
          </div>

          <div class="card shadow-none border">
            <div class="card-body p-3">
              <div class="">

                <div class="d-flex">
                  <div class="overflow-hidden me-auto">
                    <h5 class="font-size-14 text-truncate mb-1"><a href="javascript: void(0);" class="text-body">Business Location Details</a></h5>
                    <p class="text-muted text-truncate mb-0">{{business.physicalAddress}}</p>
                  </div>

                </div>

                <div class="card-body bg-light d-flex mb-4 mt-4">
                  <p class=" mb-0 ">
                    <i class="mdi mdi-map-marker text-warning align-middle me-3 font-size-24 ml-5 mr-5 "></i>
                  </p>
                  <div>
                    <p class="text-muted mb-0 ">Actual Location</p>
                    <p class="mb-0 ">
                      <strong class="fw-semibold">
                        <span class="the-clicked-address ">{{business.physicalAddress}}</span>
                      </strong>
                    </p>
                  </div>
                </div>

                <div class="card-body bg-light d-flex mb-4 mt-4">
                  <p class=" mb-0 ">
                    <i class="mdi mdi-map-legend text-warning align-middle me-3 font-size-24 ml-5 mr-5 "></i>
                  </p>
                  <div>
                    <p class="text-muted mb-0 ">Sub County & Ward</p>
                    <p class="mb-0 ">
                      <strong class="fw-semibold">
                        <span class="">{{business.subCountyName}}, {{business.w}}</span>
                      </strong>
                    </p>
                  </div>
                </div>



                <div class="card-body bg-light d-flex mb-4 mt-4">
                  <p class=" mb-0 ">
                    <i class="mdi mdi-home-map-marker text-warning align-middle me-3 font-size-24 ml-5 mr-5 "></i>
                  </p>
                  <div>
                    <p class="text-muted mb-0 ">Address</p>
                    <p class="mb-0 ">
                      <strong class="fw-semibold">
                        <span class="">{{business.physicalAddress}}</span>
                      </strong>
                    </p>
                  </div>
                </div>


                <div class="card-body bg-light d-flex mb-4 mt-4">
                  <p class=" mb-0 ">
                    <i class="mdi mdi-office-building-outline text-warning align-middle me-3 font-size-24 ml-5 mr-5 "></i>
                  </p>
                  <div>
                    <p class="text-muted mb-0 ">Door Number and Floor</p>
                    <p class="mb-0 ">
                      <strong class="fw-semibold">
                        <span class="">Door No. {{business.roomNo}}, {{business.buildingName}} {{business.floorNo}}</span>
                      </strong>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>



      <footer class="footer ">
        <div class="container-fluid ">
          <div class="row ">
            <div class="col-sm-6 ">> ©County
            </div>
            <div class="col-sm-6 ">
              <div class="text-sm-end d-sm-block ">
                LeadCab
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
    <!-- end main content-->

  </div>
  <!-- END layout-wrapper -->


  <!-- Right bar overlay-->
  <div class="rightbar-overlay "></div>

  </body>

</template>

<script>
/* eslint-disable */
import NavigationBar from "@/components/Navigation";
import ToolBar from "@/components/sbp/ToolBar";
import {trade, execute, biller} from "@/api";
import moment from "moment";


export default {
  name: "CertBizOngoing",
  components: {ToolBar, NavigationBar},
  data() {
    return {
      isActive: true,
      batchTimer: null,
      county: {
        id: null,
        countyID: null,
        countyName: null,
        tagline: null,
        smsusername: null,
        smspassword: null,
        contact: null,
        center: null,
        address: null,
        email: null,
        headline: null,
        tagline2: null,
        ussd: null,
        logo: null,
        bank: null,
        powered: null,
        stateLogo: null,
        seal: null,
        signature: null,
        lat: null,
        lng: null,
        link: null,
        paysol: null,
        poweredByLogo: null,
        mobileApp: null,
        selfService: null
      },
      color: 'alert-success',
      business: {
        id: null,
        businessID: null,
        businessName: null,
        subCountyName: null,
        wardName: null,
        physicalAddress: null,
        businessCategory: null,
        businessSubCategory: null,
        buildingName: null,
        businessDes: null,
        status: null,
        receiptAmount: null,
        startDate: null,
        endDate: null,
        billNo: null,
        dateOfIssue: null,
        issuingOfficer: null,
        lastRenewed: null,
        floorNo: null,
        roomNo: null,
        lat: null,
        lng: null,
        permitsCount: null
      },
      nonCompliant: [],
      compliant: [],
      loading: false,
      loadingMessage: "Loading map data...",
      batchSize: 50,
      compliantPage: 1,
      nonCompliantPage: 1,
      compliantComplete: false,
      nonCompliantComplete: false,
      mapInitialized: false,
      map: null,
      markers: {
        compliant: [],
        nonCompliant: []
      },
      activeBathType: 'compliant',
      message: ''
    }
  },
  beforeDestroy() {
    this.cleanup();
  },

  beforeRouteLeave(to, from, next) {
    this.cleanup();
    next();
  },


  mounted() {
    this.initMap();
    this.menuAccess();
    this.loadBatch('nonCompliant');
    this.loadBatch('compliant');

  },
  methods: {

    cleanup() {
      // Set flag to stop any pending batches
      this.isActive = false;

      // Clear any timers
      if (this.batchTimer) {
        clearTimeout(this.batchTimer);
        this.batchTimer = null;
      }

      // Clear marker arrays to release memory
      if (this.markers) {
        if (this.markers.compliant) {
          this.markers.compliant.forEach(marker => {
            marker.setMap(null);
          });
          this.markers.compliant = [];
        }

        if (this.markers.nonCompliant) {
          this.markers.nonCompliant.forEach(marker => {
            marker.setMap(null);
          });
          this.markers.nonCompliant = [];
        }
      }},
    menuAccess() {
      const data = new FormData();
      data.append("function", "menuAccess");
      data.append("menu", "SBP Maps");
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));
      execute(data, biller)
          .then((res) => {
            // Access logic here
          })
          .catch((e) => {
            // Error handling
          });
    },

    loadBatch(type) {

      if (!this.isActive ||
          (type === 'compliant' && this.compliantComplete) ||
          (type === 'nonCompliant' && this.nonCompliantComplete)) {
        return;
      }

      this.loading = true;
      this.activeBathType = type;

      const page = type === 'compliant' ? this.compliantPage : this.nonCompliantPage;

      const data = new FormData();
      data.append("function", "sbpMapBatch");
      data.append("type", type);
      data.append("page", page);
      data.append("limit", this.batchSize);

      execute(data, trade)
          .then((res) => {
            if (res.data.success) {
              // Update county info only on first load
              if (!this.mapInitialized && type === 'compliant' && page === 1) {
                this.county = res.data.data.county;
              }

              // Append new data
              if (type === 'compliant') {
                const newData = res.data.data.records || [];
                this.compliant = [...this.compliant, ...newData];
                this.compliantPage++;

                if (newData.length < this.batchSize) {
                  this.compliantComplete = true;
                }
              } else {
                const newData = res.data.data.records || [];
                this.nonCompliant = [...this.nonCompliant, ...newData];
                this.nonCompliantPage++;

                if (newData.length < this.batchSize) {
                  this.nonCompliantComplete = true;
                }
              }

              // Add markers for this batch
              this.addMarkersForBatch(type === 'compliant' ?
                  res.data.data.records :
                  res.data.data.records, type);

              // Initialize map if not done yet and we have county data
              if (!this.mapInitialized && this.county.lat && this.county.lng) {
                this.initMapWithData();
                this.mapInitialized = true;
              }

              // Load next batch if needed
              if (type === 'compliant') {
                if (!this.compliantComplete) {
                  this.loadBatch('compliant');
                } else if (!this.nonCompliantComplete) {
                  this.loadBatch('nonCompliant');
                } else {
                  this.loading = false;
                }
              } else {
                if (!this.nonCompliantComplete) {
                  this.loadBatch('nonCompliant');
                } else if (!this.compliantComplete) {
                  this.loadBatch('compliant');
                } else {
                  this.loading = false;
                }
              }
            } else {
              this.message = res.data.message;
              this.loading = false;
            }
          })
          .catch((e) => {
            this.message = e.message;
            this.loading = false;
          });
    },

    initMap() {
      // Create an initial empty map
      const defaultLat = -1.286389; // Default Kenya coordinates if county data not loaded yet
      const defaultLng = 36.817223;

      const options = {
        zoom: 10,
        center: { lat: defaultLat, lng: defaultLng },
        mapTypeId: google.maps.MapTypeId.SATELLITE // Set default map type to satellite
      };

      this.map = new google.maps.Map(document.getElementById('map'), options);

      // Set up search box and other map controls
      this.setupMapControls();
    },

    initMapWithData() {
      if (!this.map) return;

      // Center map on county coordinates if available
      if (this.county.lat && this.county.lng) {
        const latitude = parseFloat(this.county.lat);
        const longitude = parseFloat(this.county.lng);
        this.map.setCenter({lat: latitude, lng: longitude});
      }
    },

    addMarkersForBatch(businesses, type) {
      if (!businesses || !this.map) return;

      businesses.forEach(item => {
        if (!item.lat || !item.lng) return;

        let iconImage = null;
        let color = '';

        if (type === 'nonCompliant') {
          // For non-compliant businesses, use the red icon
          iconImage = "assets/images/map-assets/biz/noncomplant-business.png";
          color = 'alert-danger';
        } else {
          // For compliant businesses, use the green icon
          iconImage = "assets/images/map-assets/biz/compliant-biz-business.png";
          color = 'alert-success';
        }

        this.addMarker(item, iconImage, color);
      });
    },

    // Replace the addMarker method with this enhanced version
    addMarker(business, iconUrl, color) {
      if (!business.lat || !business.lng) return;

      // Create the marker but don't add it to the map yet
      const marker = new google.maps.Marker({
        position: {lat: Number(business.lat), lng: Number(business.lng)},
        // Don't set map property yet
        icon: {
          url: iconUrl,
          scaledSize: new google.maps.Size(19.7, 27.9),
          origin: new google.maps.Point(0, 0),
          anchor: new google.maps.Point(0, 0)
        }
      });

      // Store marker reference for later
      if (business.endDate && new Date(business.endDate) < new Date()) {
        this.markers.nonCompliant.push(marker);
      } else {
        this.markers.compliant.push(marker);
      }

      // Create info window content
      const content = this.createInfoWindowContent(business, color);
      const infowindow = new google.maps.InfoWindow({
        content: content
      });

      // Add hover event
      marker.addListener('mouseover', () => {
        infowindow.open(this.map, marker);
      });

      marker.addListener('mouseout', () => {
        infowindow.close();
      });

      // Add click event
      marker.addListener('click', () => {
        this.business = business;
        this.color = color;
        this.toggleBounce(marker);

        const theCanvas = new bootstrap.Offcanvas(document.getElementById('offcanvasExample'));
        theCanvas.show();
      });

      // Apply a custom animation
      this.animateMarkerOntoMap(marker);
    },

// Add this new method for animating markers
    animateMarkerOntoMap(marker) {
      // Randomize the delay for a more natural appearance (between 0 and 2 seconds)
      const delay = Math.random() * 2000;

      // Apply a random animation type
      const animationType = Math.floor(Math.random() * 4);

      setTimeout(() => {
        // Add marker to map
        marker.setMap(this.map);

        // Apply the selected animation
        switch (animationType) {
          case 0: // Bounce effect
            marker.setAnimation(google.maps.Animation.BOUNCE);
            setTimeout(() => {
              marker.setAnimation(null);
            }, 1500);
            break;

          case 1: // Grow effect
            this.growEffect(marker);
            break;

          case 2: // Spin effect
            this.spinEffect(marker);
            break;

          case 3: // Pop effect
            this.popEffect(marker);
            break;

          default:
            // Fallback to bounce
            marker.setAnimation(google.maps.Animation.BOUNCE);
            setTimeout(() => {
              marker.setAnimation(null);
            }, 1500);
        }
      }, delay);
    },

// Add methods for different animation effects
    growEffect(marker) {
      // Start with a small icon
      const icon = marker.getIcon();
      const originalSize = {
        width: icon.scaledSize.width,
        height: icon.scaledSize.height
      };

      // Start small
      icon.scaledSize = new google.maps.Size(1, 1);
      marker.setIcon(icon);

      // Grow over time
      let size = 0;
      const growInterval = setInterval(() => {
        size += 0.1;
        if (size >= 1) {
          clearInterval(growInterval);
          // Set back to original size
          icon.scaledSize = new google.maps.Size(originalSize.width, originalSize.height);
          marker.setIcon(icon);
          return;
        }

        icon.scaledSize = new google.maps.Size(
            originalSize.width * size,
            originalSize.height * size
        );
        marker.setIcon(icon);
      }, 20);
    },

    spinEffect(marker) {
      const icon = marker.getIcon();
      let rotation = 0;
      const spinInterval = setInterval(() => {
        rotation += 30; // degrees per frame
        if (rotation >= 360) {
          clearInterval(spinInterval);
          return;
        }

        // Create a new icon with rotation
        const rotatedIcon = {
          ...icon,
          rotation: rotation
        };
        marker.setIcon(rotatedIcon);
      }, 30);
    },

    popEffect(marker) {
      // Start invisible
      marker.setOpacity(0);

      // Pop up and bounce slightly
      const icon = marker.getIcon();
      const originalSize = {
        width: icon.scaledSize.width,
        height: icon.scaledSize.height
      };

      // Sequence: pop up (larger than final), shrink back, slight bounce
      setTimeout(() => {
        marker.setOpacity(1);
        // Pop larger
        icon.scaledSize = new google.maps.Size(
            originalSize.width * 1.5,
            originalSize.height * 1.5
        );
        marker.setIcon(icon);

        setTimeout(() => {
          // Shrink back
          icon.scaledSize = new google.maps.Size(
              originalSize.width * 0.8,
              originalSize.height * 0.8
          );
          marker.setIcon(icon);

          setTimeout(() => {
            // Final size
            icon.scaledSize = new google.maps.Size(
                originalSize.width,
                originalSize.height
            );
            marker.setIcon(icon);
          }, 100);
        }, 150);
      }, 100);
    },

    createInfoWindowContent(business, color) {
      // Create the HTML content for the info window
      return `<p class="d-none">application|identifier</p><h6 class="d-flex align-items-center">
<div class="card mb-0">
    <div class="card-body px-0 mb-3">
           <div class="d-flex">
           <div class="flex-grow-1 overflow-hidden pe-5">
               <h5 class="text-truncate font-size-16 mb-1 text-capitalize">
                ${business.businessName}
               </h5>
               <p class="text-truncate text-uppercase text-grey mb-4">${business.subCountyName}</p>
           </div>
           </div>
    </div>

    <div class="alert alert-info">
        <strong>Business Location</strong>
        <p class="text-muted mb-0"><i class="mdi mdi-map-marker text-success align-middle me-1 font-18px"></i>
        <span class="the-clicked-address">${business.physicalAddress}</span> </p>
    </div>

    <div class="alert ${color}" role="alert">
       <strong>Business Category</strong>
       <p>${business.businessCategory}</p>

       <strong>Business Sub Category</strong>
       <p>${business.businessSubCategory}</p>

       <strong>Renewal Fee Paid</strong>
        <h5>KES ${this.numberFormat(business.receiptAmount)}</h5>

        <a class="text-info text-uppercase mt-4 fw-semibold">Receipt No. ${business.billNo}</a>
    </div>

    <div class="card-body">
        <ul class="verti-timeline list-unstyled">
            <li class="event-list">
                <div class="event-timeline-dot">
                    <i class="mdi mdi-square font-size-18 text-black"></i>
                </div>
                <div class="d-flex">
                    <div class="flex-grow-1">
                    <span class="text-muted">
                     Application date
                    </span>
                        <div>
                        Done By ${business.issuingOfficer} On ${business.dateOfIssue}
                        </div>
                    </div>
                </div>
            </li>
            <li class="event-list">
                <div class="event-timeline-dot">
                    <i class="mdi mdi-circle font-size-18 text-primary"></i>
                </div>
                <div class="d-flex">
                    <div class="flex-grow-1">
                    <span class="text-muted">
                     Last Renewed
                    </span>
                        <div>
                        ${business.lastRenewed}
                        </div>
                    </div>
                </div>
            </li>
        </ul>
    </div>
</div>`;
    },

    toggleBounce(marker) {
      if (marker.getAnimation() !== null) {
        marker.setAnimation(null);
      } else {
        marker.setAnimation(google.maps.Animation.BOUNCE);
        setTimeout(() => {
          marker.setAnimation(null);
        }, 750);
      }
    },

    setupMapControls() {
      // Setup search box
      const input = document.getElementById("pac-input");
      const searchBox = new google.maps.places.SearchBox(input);
      this.map.controls[google.maps.ControlPosition.TOP_LEFT].push(input);

      // Bias the SearchBox results towards current map's viewport
      this.map.addListener("bounds_changed", () => {
        searchBox.setBounds(this.map.getBounds());
      });

      // Setup search box events
      $('#pac-input').on('click', () => {
        $('.map-info-cont').addClass('left-100');
      });

      $('#pac-input').on('keyup', () => {
        $('.clear-map i').removeClass('d-none');
        $('.map-info-cont').addClass('left-100');
      });

      // Setup clear button
      $('.clear-map').on('click', () => {
        $('.form-map-locations .clicked-subcounty').text("Not Selected").addClass('text-danger').removeClass('text-black');
        $('.form-map-locations .clicked-address').text("Not Selected").addClass('text-danger').removeClass('text-black');
        $('.form-map-locations .clicked-ward').text("Not Selected").addClass('text-danger').removeClass('text-black');
        $('.form-map-locations .clicked-street').text("Not Selected").addClass('text-danger').removeClass('text-black');

        $('#pac-input').val("");
        $('.clear-map i').addClass('d-none');
        $('.map-info-cont').addClass('left-100');
      });

      // Handle search box place changes
      searchBox.addListener("places_changed", () => {
        const places = searchBox.getPlaces();

        if (places.length == 0) {
          return;
        }

        // For each place, get the location
        const bounds = new google.maps.LatLngBounds();

        places.forEach(place => {
          if (!place.geometry) {
            console.log("Returned place contains no geometry");
            return;
          }

          // Create a marker for the place
          const marker = new google.maps.Marker({
            map: this.map,
            title: place.name,
            position: place.geometry.location,
            icon: {
              size: new google.maps.Size(25, 25),
              scaledSize: new google.maps.Size(25, 25),
            }
          });

          // Create info window for search result
          const infowindow = new google.maps.InfoWindow({
            content: `<strong>${place.name}</strong><br><p class="text-info text-underline">Click Icon for more options</p>`
          });

          marker.addListener('mouseover', () => {
            infowindow.open(this.map, marker);
          });

          marker.addListener('mouseout', () => {
            infowindow.close();
          });

          marker.addListener('click', (e) => {
            this.toggleBounce(marker);
            const coords = e.latLng.toString();

            // Parse coordinates
            let lat = coords.substring(coords.indexOf("(") + 1, coords.indexOf(","));
            let lng = coords.substring(coords.lastIndexOf(",") + 1, coords.indexOf(")"));

            // Do reverse geocoding
            this.reverseGeocoding(lat, lng);

            $('#newPoint').removeClass('left-100').siblings().addClass('left-100');
          });

          if (place.geometry.viewport) {
            bounds.union(place.geometry.viewport);
          } else {
            bounds.extend(place.geometry.location);
          }
        });

        this.map.fitBounds(bounds);
      });
    },

    reverseGeocoding(latitude, longitude) {
      const apiKey = "AIzaSyBl3dCvpVQUs04SOTCHgITw4Ts79-dRcfI";
      const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${apiKey}`;

      fetch(url)
          .then(response => response.json())
          .then(data => {
            if (!data.results || data.results.length === 0) return;

            const address = data.results[0].formatted_address;
            let subCounty = "", ward = "", street = "";

            // Extract address components
            data.results.forEach(result => {
              const components = result.address_components;

              components.forEach(part => {
                if (part.types.includes("administrative_area_level_2")) {
                  subCounty = part.long_name;
                }
                if (part.types.includes("administrative_area_level_4") ||
                    part.types.includes("sublocality_level_1")) {
                  ward = part.long_name;
                }
                if (part.types.includes("route")) {
                  street = part.long_name;
                }
              });
            });

            // Update display with address info
            $('#newPoint .clicked-ward').text(ward);
            $('.form-map-locations .clicked-ward').text(ward).addClass('text-black').removeClass('text-danger');

            $('#newPoint .clicked-street').text(street);
            $('.form-map-locations .clicked-street').text(street).addClass('text-black').removeClass('text-danger');

            $('#newPoint .clicked-subcounty').text(subCounty);
            $('.form-map-locations .clicked-subcounty').text(subCounty).addClass('text-black').removeClass('text-danger');

            $('#newPoint .clicked-address').text(address);
            $('.form-map-locations .clicked-address').text(address).addClass('text-black').removeClass('text-danger');
            $('.form-map-locations .form-address').val(address);

            $('.form-map-locations .form-latitude').val(latitude);
            $('.form-map-locations .form-longitude').val(longitude);

            $('.permits-asside .the-clicked-address').text(address);
            $('.the-clicked-address').text(address);

            $('#plate .plate-address').text(address);
            $('#application .plate-address').text(address);

            $('#plate .plate-street').text(street);
            $('#application .plate-street').text(street);

            $('#multi-plate .plate-street').text(street);
            $('#multi-plate .plate-address').text(address);
          })
          .catch(err => {
            console.warn("Geocoding error:", err.message);
          });
    },

    formatDate(date) {
      if (!date) return '';

      let d = new Date(date);
      let day = d.getDate();
      let month = d.toLocaleString('en-US', { month: 'short' });
      let year = d.getFullYear();

      let suffix = '';
      if (day % 10 === 1 && day !== 11) {
        suffix = 'st';
      } else if (day % 10 === 2 && day !== 12) {
        suffix = 'nd';
      } else if (day % 10 === 3 && day !== 13) {
        suffix = 'rd';
      } else {
        suffix = 'th';
      }
      return `${day}${suffix} ${month} ${year}`;
    },

    formattedTime(time) {
      return moment(time).format('hh:mm A');
    },

    numberFormat(num) {
      if (!num) return '0';
      const britishNumberFormatter = new Intl.NumberFormat("en-GB");
      return britishNumberFormatter.format(num);
    },

    printTradePermit(businessID) {
      const data = new FormData();
      data.append("function", "printTradePermit");
      data.append("businessID", businessID);
      execute(data, trade)
          .then((res) => {
            if (res.data.success) {
              localStorage['params'] = JSON.stringify({
                businessID: businessID
              });
              const routeData = this.$router.resolve({name: 'trade'});
              window.open(routeData.href, '_blank');
            } else {
              this.businessNotFound = true;
            }
          })
          .catch((e) => {
            alert(e.message);
          });
    }
  }
}

</script>

<style scoped>

</style>